'use client';
import 'client-only';

import { ToolsArchiveFeature } from '../common/features/tools-archive-feature';
import { createUseFlag } from './create-use-flag';

export const useToolsArchiveFeature = createUseFlag(ToolsArchiveFeature);
